export const actionTypes = {
  SET_TRANSPORT_ORDER_DATA: 'SET_TRANSPORT_ORDER_DATA',
  SET_TRANSPORT_ORDER_STATUS_HISTORY: 'SET_TRANSPORT_ORDER_STATUS_HISTORY',
};

export default actionTypes;
